import van from 'vanjs-core';
import {getSum} from "../../tools/tools";

const {div, span} = van.tags;

// Ukazatel osazené plochy FVE na 1. obrazovce
export const Page1AreaPlant = (stateVar) => {

    return div({class: "item d-flex flex-column align-items-center w-100 sm-hide"},
        div({class: "bt-spacer sm-hide"}),
        div(
            span({class: "big-text text-dark-blue smaller"}, getSum(stateVar.val)),
            span({class: "unit-text ms-2 text-dark-blue"}, "m2"),
        ),
        div({class: "bg-blue pl-tag w-100 md-tag-padding md-tag-border"},
            span({class: "text-white me-2 md-tag-text"}, "AREA PLANT"),
            span({class: "text-light-blue md-tag-text"}, "OSAZENÁ PLOCHA"),
        ),
    );
}

// Ukazatel jmenovitého výkonu na 1. obrazovce
export const Page1NominalPower = (stateVar) => {

    return div({class: "item d-flex flex-column align-items-center w-100 sm-hide mt-3"},
        div({class: "bt-spacer sm-hide"}),
        div(
            span({class: "big-text text-dark-blue smaller"}, getSum(stateVar.val)),
            span({class: "unit-text ms-2 text-dark-blue"}, "kWp"),
        ),
        div({class: "bg-blue pl-tag w-100 md-tag-padding md-tag-border"},
            span({class: "text-white me-2 md-tag-text"}, "NOMINAL POWER"),
            span({class: "text-light-blue md-tag-text"}, "JMENOVITÝ VÝKON"),
        ),
    );
}

// Ukazatel osazené plochy FVE a jmenovitého výkonu na 1. obrazovce vedle sebe nad obrázkem při mobilním rozlišení
export const Page1NominalPowerAreaPlantSm = (stateVar1, stateVar2) => {

    return div({class: "item flex-row align-items-center justify-content-between w-100 sm-show mb-3"},
        div({class: "item d-flex flex-column align-items-center w-50 pe-3"},
            div({class: "fw-bold text-dark"},
                span({class: "big-text text-dark-blue smaller"}, getSum(stateVar1.val)),
                span({class: "unit-text ms-2 text-dark-blue"}, "kWp"),
            ),
            div({class: "bg-blue pl-tag w-100 md-tag-padding md-tag-border wf column-tag"},
                span({class: "text-white me-2 md-tag-text"}, "NOMINAL POWER"),
                div({class: "spacer"}),
                span({class: "text-light-blue md-tag-text"}, "JMENOVITÝ VÝKON"),
            ),
        ),
        div({class: "item d-flex flex-column align-items-center w-50 ps-3"},
            div({class: "fw-bold text-dark"},
                span({class: "big-text text-dark-blue smaller"}, getSum(stateVar2.val)),
                span({class: "unit-text ms-2 text-dark-blue"}, "m2"),
            ),
            div({class: "bg-blue pl-tag w-100 md-tag-padding md-tag-border wf column-tag"},
                span({class: "text-white me-2 md-tag-text"}, "AREA PLANT"),
                div({class: "spacer"}),
                span({class: "text-light-blue md-tag-text"}, "OSAZENÁ PLOCHA"),
            ),
        ),
    );
}